// extracted by mini-css-extract-plugin
var _1 = "AuthFooter-moduleAuthFooter__qWvDg";
var _2 = "AuthFooter-moduleabout__f86I3";
var _3 = "AuthFooter-moduleaboutLink__hHybv AuthFooter-modulelink__XVLGW";
var _4 = "AuthFooter-modulelink__XVLGW";
var _5 = "AuthFooter-modulewithNotifications__d6n5d";
export { _1 as "AuthFooter", _2 as "about", _3 as "aboutLink", _4 as "link", _5 as "withNotifications" }
